import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/order/pre_ticket'
export function getList(params) {
  return axios.get(`${ApiUrl}/record`, {
    params
  })
}
export function cancel(id) {
  return axios.post(`${ApiUrl}/${id}/cancel/`)
}

export function batch(data) {
  return axios.post(`${ApiUrl}/batch/`, data)
}

export function sendTicketMsg(pre_ticket_id) {
  return axios.post(`/admin_api/v1/order/send_ticket_sms/`, { pre_ticket_id })
}
